import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { StorageService } from 'src/app/Services/storage.service';

@Component({
    selector: 'app-single-view-driver',
    templateUrl: './singleDriver.html'

})
export class SingleViewDriverComponent {

    public breadcrumbData = {
        "Information": "/organization/transport-manager/information",
        "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
    };
    driverData: any;
    orgID: string;
    vendorID: string;
    driverID: string;
    licenceImage:any;
    licenceImageName:string;
    profilePic:any;
    enableCard:boolean = false;
    licenceShow:boolean = false;

    constructor(
        public storage: StorageService,
        public api: ApiService,
        public router: Router,
        public route: ActivatedRoute,
        public file:FileUploadService,
        public comService:CommonServices

    ) {
        this.orgID= this.storage.get('userInfo').orgID;
        let vendorName = this.storage.get('vendorID_orgID')['vendorName'];
        this.route.paramMap.subscribe((params: any) => {
            this.vendorID = params.params.vendorID;
            this.driverID = params.params.driverID;


            if(vendorName){
              vendorName = this.comService.strTruncate(vendorName,13);
              this.breadcrumbData[vendorName] =  "/organization/transport-manager/information/vendor/single-view-vendor/"+this.vendorID;
            }else{
              this.breadcrumbData['Vendor'] = "/organization/transport-manager/information/vendor/single-view-vendor/"+this.vendorID;
            }            
            this.breadcrumbData['Drivers'] = "organization/transport-manager/information/driver/view-driver/" + this.vendorID;
        });
        

    }

    ngOnInit() {
this.getDriverData();
    }
    getDriverData() {
        const obj = {
            orgID : this.orgID,
            vendorID: this.vendorID,
            driverID: this.driverID
        };
        this.api.transportManagerDriverList(obj).then((res: any) => {
            if (res.status == 'success') {
                this.driverData = res.data[0];
                this.licenceImageName = `${this.comService.strReplace(this.driverData['name'],' ','_')}_Licence.jpg`;
                if(this.driverData.licence) this.licenceShow = true;
                this.licenceImage = this.convertURLintoImg(this.driverData.licence);
                this.profilePic = this.convertURLintoImg(this.driverData.profilePic);
                console.log(this.licenceImage)
                this.enableCard = true;
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    licenceImgError(){
        this.licenceShow = false;
    }

    downloadLicence(){
        console.log(this.licenceImage);
        document.getElementById('licenceID').click();
    }

    async convertURLintoImg(url){
        let imageFile = await this.file.urlHandleBase64(url);
        console.log(imageFile);
        return imageFile;
    }
}
